module.exports = __webpack_public_path__ + "static/media/loss-prevention.8bb3615b.jpg";